// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Lout5","logo":"style__logo__51jx3","name":"style__name__O5qDK"};